export default import.meta.ROLLUP_FILE_URL_IIsxV7dDE3Abxr7YbOqTaQ